import { defaultSchema } from 'rehype-sanitize';

import { safeAgentMarkdownHref } from './safe-url';

// Hardening for untrusted agent-authored markdown (AI-949 / f-84), used by the block renderer
// (StreamingText) — which also renders the approval-block description — so agent prose is sanitized
// identically: GitHub's safe schema, URLs constrained to https/mailto.
export const agentMarkdownSanitizeSchema = {
  ...defaultSchema,
  // remark-gfm already namespaces footnote ids with `user-content-`; empty prefix avoids a double-prefix that breaks footnote anchors.
  clobberPrefix: '',
  protocols: {
    ...defaultSchema.protocols,
    href: ['https', 'mailto'],
    src: ['https'],
  },
  attributes: {
    ...defaultSchema.attributes,
    // remarkPromoteTableTitles stashes the preceding label on the table; allow it through sanitize.
    table: [...(defaultSchema.attributes?.['table'] ?? []), 'dataTableTitle'],
  },
};

// Protocol-relative URLs (//host, and the /\, \/, \\ variants browsers normalize to it) carry no scheme, so the
// sanitizer's protocol allowlist skips them; on an https page they resolve to https://host and slip past https/mailto.
export function hardenAgentUrl(url: string): string {
  if (/^\s*[/\\]{2}/.test(url)) return '';
  return safeAgentMarkdownHref(url) ?? '';
}
